<template>
	<div class="main">
		<div class="modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<span class="modal-title">{{!isEdit ? '新增' : '編輯'}}離宿日期時段</span>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePopup">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row form-group">
							<div class="col-md-8 form-group">
								<label for="year" class="col-sm-4 col-xs-2 column-required">日期</label>
								<div class="col-sm-8 col-xs-10">
									<datepicker id="date" name="date" v-model="form.date" v-validate="'required'" :format="customFormatter" :language="zh" style="display: inline-block;"/>
									<span class="text-danger" v-show="errors.has('date')">{{ errors.first('date') }}</span>
								</div>
							</div>
            </div>
            <div class="row form-group">
							<div class="col-md-8 form-group">
								<label for="applyType" class="col-sm-4 col-xs-2 column-required">時段</label>
								<div class="col-sm-4 col-xs-5">
                  <div class="input-checkbox">
                    <input id="periods_07_08" name="periods_07_08" type="checkbox" value="07-08" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_07_08">07-08</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_08_09" name="periods_08_09" type="checkbox" value="08-09" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_08_09">08-09</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_09_10" name="periods_09_10" type="checkbox" value="09-10" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_09_10">09-10</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_10_11" name="periods_10_11" type="checkbox" value="10-11" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_10_11">10-11</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_11_12" name="periods_11_12" type="checkbox" value="11-12" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_11_12">11-12</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_12_13" name="periods_12_13" type="checkbox" value="12-13" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_12_13">12-13</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_13_14" name="periods_13_14" type="checkbox" value="13-14" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_13_14">13-14</label>
                  </div>
								</div>
                <div class="col-sm-4 col-xs-5">
                  <div class="input-checkbox">
                    <input id="periods_14_15" name="periods_14_15" type="checkbox" value="14-15" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_14_15">14-15</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_15_16" name="periods_15_16" type="checkbox" value="15-16" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_15_16">15-16</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_16_17" name="periods_16_17" type="checkbox" value="16-17" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_16_17">16-17</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_17_18" name="periods_17_18" type="checkbox" value="17-18" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_17_18">17-18</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_18_19" name="periods_18_19" type="checkbox" value="18-19" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_18_19">18-19</label>
                  </div>
                  <div class="input-checkbox">
                    <input id="periods_19_20" name="periods_19_20" type="checkbox" value="19-20" v-model="form.periods" v-validate="'required'"/>
                    <label for="periods_19_20">19-20</label>
                  </div>
                </div>
                <span class="text-danger" v-show="errors.has('periods')">{{ errors.first('periods') }}</span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
            <input id="isCreateAnother" name="isCreateAnother" type="checkbox"  v-model="isCreateAnother" v-if="!isEdit"/>
            <label for="isCreateAnother" v-if="!isEdit">新增下一筆(日期自動加一天，保留時段)</label>
						<button type="button" class="btn btn-primary" @click="handleSave">{{!isEdit ? '新增' : '儲存'}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['data', 'isEdit'],
	data(){
		return {
			form: null,
      isCreateAnother: true
		}
	},
	beforeMount(){
		this.form = this.isEdit ?
      {
        ...this.data,
        date: new Date(this.data.date+"+0000"),
        orgDate: this.data.date
      } :
      {
        date: '',
        periods: []
      };
	},
	methods:{
		handleSave() {
			this.$validator.validateAll().then((result) => {
				if (result) {
          if(this.data == null) {
            // 轉換時區
            this.form.date = new Date(this.form.date);
            // 新增
            const api = `/api/room/createDormitoryLeaveDatePeriod`;
            this.$axios.post(api, this.form).then(resp => {
              if (resp.data.status === "success") {
                bootbox.alert("儲存成功");
                if(this.isCreateAnother) {
                  var oldDate = new Date(this.form.date);
                  var newDate = oldDate.setDate(oldDate.getDate() + 1);
                  this.form.date = this.customFormatter(newDate);
                  this.$parent.updateGrid();
                } else {
                  this.closePopup();
                }
              } else {
                bootbox.alert(resp.data.msg);
              }
            });
          } else {
            // 編輯
            const api = `/api/room/updateDormitoryLeaveDatePeriod`;
            this.$axios.post(api, this.form).then(resp => {
              if (resp.data.status === "success") {
                bootbox.alert("儲存成功");
                this.closePopup();
              } else {
                bootbox.alert(resp.data.msg);
              }
            });
          }
				} else {
					bootbox.alert("請確認必填欄位是否有填寫")
				}
			});
		},
		closePopup() {
			this.$parent.isOpenEditPopup = false;
      this.$parent.updateGrid();
		}
	}
}
</script>
